module.exports = __webpack_public_path__ + "img/icon_star_inactive_silver.346f0586.svg";